export default {
  page: function () {
    this.loadItems()
  }
}
